import { postApi } from "./general.service";

// Única implementación de traducción DeepL del backoffice (antes había 6 copias del
// fetch manual en los editores de Notifications). Usa el axios compartido (auth global).
export const translateText = async (text, targetLang) => {
  const resp = await postApi("/translation/deepl", { title: text, lang: targetLang });
  return resp?.data?.translations?.[0]?.text ?? null;
};

// Traduce un texto EN → varios idiomas. Devuelve {es: "...", fr: "..."} (omite fallos).
export const translateToLangs = async (text, targetLangs) => {
  const entries = await Promise.all(
    targetLangs.map(async (lang) => [lang, await translateText(text, lang).catch(() => null)]),
  );
  return Object.fromEntries(entries.filter(([, value]) => value));
};
